const state = {
    data: {},
    setData(componentIndex, data) {
        let currentData = this.getData(componentIndex);
        this.data[componentIndex] = Object.assign(currentData, data);
    },
    getData(componentIndex) {
        return this.data[componentIndex] || {selected: [], excluded: [], allSelected: false, totalRows: 0, filters: {}};
    }
}

const getters = {
    getSelection: (state) => (componentIndex) => {
        return state.getData(componentIndex);
    },
    getTotalRecordsNumberForSelections: (state) => (componentIndex) => {
        let data = state.getData(componentIndex);

        return data['totalRows'];
    },
    getRecordsNumberForSelections: (state) => (componentIndex) => {
        let data = state.getData(componentIndex);

        if ((!data['allSelected'] && 0 === data['selected'].length) || 0 === data['totalRows']) {
            return 0;
        }

        if (data['allSelected']) {
            return data['totalRows'] - data['excluded'].length;
        }

        return data['selected'].length;
    }
}

const actions = {
}

const mutations = {
    setState(state, data) {
        state.setData(data.componentIndex, data.data);
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/gridSelections.js